import {connect} from 'react-redux';
import InsurancesStepView from '../../../components/views/mx/creditoReal/InsurancesStepView';
import * as WizardActions from '../../../actions/WizardActions';
import * as WizardMXActions from '../../../actions/WizardMXActions';
import * as ModalActions from '../../../actions/ModalActions';
import {MODAL_TYPE} from '../../../constants/ModalConstants';
import {withRouter} from 'react-router';
import {pushDataLayer} from '../../../../common/utils/GTMUtils';
import {DATA_LAYER} from '../../../../common/constants/LabelConstants';

const mapStateToProps = (state, {match}) => {
    const summaryStepView = state.creditoReal.ui.summaryStepView;
    const loanApplication = state.creditoReal.loanApplication;
    const catalog = state.catalogs;
    const allQuotationFiltered = (catalog.allQuotationInsurances || []).filter(x => x.insuranceValueByYearValue > 0)
    return {
        loanApplication,
        insuranceIncludesOptions: state.creditoReal.ui.insuranceDataStepView.insuranceIncludesOptions,
        insuranceSelectedTarget: loanApplication.insurance.insuranceSelected.target,
        allQuotationInsurances: catalog.allQuotationInsurances || [],
        allQuotationFiltered: allQuotationFiltered,
        country: state.countrySelector.countrySelected,
        hasInsuranceError: state.creditoReal.ui.insuranceDataStepView.hasInsuranceError,
        hasIncludeInsurance: state.creditoReal.calculator.hasInsurance,
        loanApplicationToken: match.params.token,
        returnToSummary: summaryStepView.returnToSummary
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onChangeIncludeInsurance: includeInsurance =>
            dispatch(WizardActions.CHANGE_INCLUDE_INSURANCE_ACTION.action(includeInsurance.value)),
        onChangeInsurance: insuranceSelected =>
            dispatch(WizardActions.CHANGE_INSURANCE_ACTION.action(insuranceSelected)),
        onShowInfo: insuranceSelected => () => {
            const header = {
                title: 'Coberturas'
            };
            const content = {
                type: MODAL_TYPE.SHOW_INSURANCES_INFO_VIEW,
                data: {
                    icon: insuranceSelected.icon,
                    name: insuranceSelected.name,
                    insuranceValueByYear: insuranceSelected.insuranceValueByYear,
                    coverages: insuranceSelected.coverages,
                }
            };
            const options = {
                closeOnOverlayClick: false
            };
            dispatch(ModalActions.OPEN_MODAL_DATA_ACTION.action(header, content, null, options));
        },
        onPressBack: () => dispatch(WizardMXActions.GO_TO_OTHER_REFERENCES_MX_ACTION.action()),
        onLoad: hasIncludeInsurance => () =>
            dispatch(WizardActions.CHANGE_INCLUDE_INSURANCE_ACTION.action(hasIncludeInsurance)),
        onPressNext: (hasIncludeInsurance, loanApplication) => () => {
            const dataLayerData = {
                type: hasIncludeInsurance ? DATA_LAYER.FUNDED : DATA_LAYER.CASH,
                insurance_carrier: hasIncludeInsurance ? loanApplication.insurance.insuranceSelected.target : ''
            };
            pushDataLayer(DATA_LAYER.INSURANCE, dataLayerData);
            dispatch(WizardMXActions.SAVE_INSURANCES_MX_ACTION.action());
        },
        getLoanApplication: token => () =>
            dispatch(WizardMXActions.GET_LOAN_APPLICATION_SUMMARY_MX_ACTION.action(token))
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    return {
        ...stateProps,
        ...dispatchProps,
        insuranceIncludesOptions: stateProps.insuranceIncludesOptions.map(item => ({
            ...item,
            defaultChecked: item.value ? stateProps.hasIncludeInsurance : !stateProps.hasIncludeInsurance
        })),
        onLoad: dispatchProps.onLoad(stateProps.hasIncludeInsurance),
        allQuotationInsurances: stateProps.allQuotationInsurances.map(item => ({
            ...item,
            onShowInfo: dispatchProps.onShowInfo(item)
        })),
        getLoanApplication: dispatchProps.getLoanApplication(stateProps.loanApplicationToken),
        onPressNext: dispatchProps.onPressNext(stateProps.hasIncludeInsurance, stateProps.loanApplication)
    };
};

const InsurancesStepContainer = withRouter<any, any>(connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(InsurancesStepView));

export default InsurancesStepContainer;
